import { render, staticRenderFns } from "./ExpressPoshtaReportTableAdmin.vue?vue&type=template&id=31d57a3e&scoped=true"
import script from "./ExpressPoshtaReportTableAdmin.vue?vue&type=script&lang=js"
export * from "./ExpressPoshtaReportTableAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d57a3e",
  null
  
)

export default component.exports